/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Upgrade_Alert_IgnoreInputs */

const en_mobile_upgrade_alert_ignore = /** @type {(inputs: Mobile_Upgrade_Alert_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignore`)
};

const es_mobile_upgrade_alert_ignore = /** @type {(inputs: Mobile_Upgrade_Alert_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorar`)
};

/**
* | output |
* | --- |
* | "Ignore" |
*
* @param {Mobile_Upgrade_Alert_IgnoreInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_upgrade_alert_ignore = /** @type {((inputs?: Mobile_Upgrade_Alert_IgnoreInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Upgrade_Alert_IgnoreInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_upgrade_alert_ignore(inputs)
	return en_mobile_upgrade_alert_ignore(inputs)
});